export default "__VITE_ASSET__D5yOymr2__"